import * as React from "react";
import Svg, { SvgProps, Path, Circle } from "react-native-svg";
const SvgComponent = (props: SvgProps) => (
  <Svg width={29} height={28} fill="none" {...props}>
    <Path
      fill="#000"
      d="M2.051 27.461c-.564 0-1.047-.2-1.448-.602A1.975 1.975 0 0 1 0 25.41V8.57c0-.565.2-1.048.603-1.45a1.975 1.975 0 0 1 1.448-.602h11.155v1.23H2.051a.799.799 0 0 0-.59.231.799.799 0 0 0-.23.59V25.41c0 .24.077.436.23.59.154.154.351.23.59.23h16.841a.8.8 0 0 0 .59-.23.799.799 0 0 0 .23-.59V14.255h1.232V25.41c0 .564-.201 1.047-.603 1.449a1.975 1.975 0 0 1-1.449.602H2.052Zm16.103-15.507V9.308h-2.646V8.077h2.646V5.43h1.23v2.646h2.647v1.23h-2.646v2.647h-1.231ZM4.626 22.938h11.897l-3.667-4.882-3.446 4.349-2.292-2.738-2.492 3.271Z"
      opacity={0.4}
    />
    <Circle cx={18.349} cy={9.667} r={9.167} fill="#C0A46F" stroke="#FDFBF9" />
    <Path
      fill="#FDFBF9"
      stroke="#C0A46F"
      strokeWidth={0.5}
      d="M17.72 10.295V13h1.258v-2.705h2.704V9.037h-2.704V6.333H17.72v2.704h-2.704v1.258h2.704Z"
    />
  </Svg>
);
export default SvgComponent;
